import React from "react"
import ClinicalHistoryLauncherView from "../features/clinical-history/components/ClinicalHistoryLauncherView"

export default function ClinicalHistoryEntryPage({
  clinicId,
  isReadOnly,
  readOnlyReason,
  launcherQuery,
  setLauncherQuery,
  launcherLoading,
  launcherPatients,
  showQuickCreate,
  setShowQuickCreate,
  quickCreateForm,
  setQuickCreateForm,
  resetQuickCreateForm,
  creatingPatient,
  onCreatePatient,
  onOpenPatientHistory,
  qrLoading,
  qrGenerating,
  qrInfo,
  qrImageUrl,
  qrImageLoading,
  onGenerateQrLink,
  onCopyQrLink,
  onOpenQrLink,
  onDownloadQr,
  onPrintQrPoster,
  onOpenUpgrade,
}) {
  return (
    <ClinicalHistoryLauncherView
      clinicId={clinicId}
      isReadOnly={isReadOnly}
      readOnlyReason={readOnlyReason}
      launcherQuery={launcherQuery}
      setLauncherQuery={setLauncherQuery}
      launcherLoading={launcherLoading}
      launcherPatients={launcherPatients}
      showQuickCreate={showQuickCreate}
      setShowQuickCreate={setShowQuickCreate}
      quickCreateForm={quickCreateForm}
      setQuickCreateForm={setQuickCreateForm}
      resetQuickCreateForm={resetQuickCreateForm}
      creatingPatient={creatingPatient}
      onCreatePatient={onCreatePatient}
      onOpenPatientHistory={onOpenPatientHistory}
      qrLoading={qrLoading}
      qrGenerating={qrGenerating}
      qrInfo={qrInfo}
      qrImageUrl={qrImageUrl}
      qrImageLoading={qrImageLoading}
      onGenerateQrLink={onGenerateQrLink}
      onCopyQrLink={onCopyQrLink}
      onOpenQrLink={onOpenQrLink}
      onDownloadQr={onDownloadQr}
      onPrintQrPoster={onPrintQrPoster}
      onOpenUpgrade={onOpenUpgrade}
    />
  )
}